import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LOADDERSTATUS } from '../../../store/slices/loadderSlice';

export default ({ show, hide }) => {
  const { loadderStatus } = useSelector(state => state.loadder);
  useEffect(() => {
    if (loadderStatus === LOADDERSTATUS.SHOWLOADDER) {
      show();
    } else if (loadderStatus === LOADDERSTATUS.HIDELOADDER) {
      hide();
    }
  }, [ loadderStatus ]);

  return '';
};
